import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DeleteIcon from '@mui/icons-material/Delete';
import IosShareIcon from '@mui/icons-material/IosShare';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import esercizi from '../assets/icons/esercizi.svg';
import SearchIcon from "@mui/icons-material/Search";

import { Sessione, SessioneVuoto } from '../interfaces/Sessione';
import { MODALTYPE, ModalData, modalDataClean, ModalAlert } from '../components/ModalAlert';
import ODMTable from '../components/ODMTable';
import { Esercizio, THead, tooltipColumnIds } from '../interfaces/Esercizio';
import SessioneDetailsTable from '../components/SessioneDetailsTable';
import SpinnerODM from '../components/spinnerODM';
import axios from 'axios';
import { fetchBE } from "../utils/utils";
import MasterHeader from '../components/MasterHeder';
import { Box } from '@mui/material';

//interface SessionePageVProps {
//  token: string;
//}

const SessionePageV: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [sessione, setSessione] = useState<Sessione>(SessioneVuoto);
  const [modalData, setModalData] = useState<ModalData>(modalDataClean);
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [activities, setActivities] = useState<Esercizio[]>([]);
  const [filteredActivities, setFilteredActivities] = useState<Esercizio[]>([]);

  const fetchActivities = async () => {
    setLoading(true);
    try {
      const [data, error] = await fetchBE(`/api/v0/session/${id}/activities`)
      if (data) {
        setActivities(data);
      } else if (error) {
        if (error.message) {
          setError(error.message);
        }
      }
    } finally {
      setLoading(false);
    }
  };





  useEffect(() => {
    setLoading(true)
    if (id) {
      const headers = new Headers();
      //if (token) {
      //  headers.set('Authorization', `Token ${token}`);
      //}
      headers.set('Accept', 'application/json');
      const requestInit: RequestInit = {
        method: 'GET',
        headers: headers,
        credentials: 'include',
      }
      fetch(`/api/v0/session/${id}`, requestInit)
        .then(response => response.json())
        .then(data => {
          setSessione(data)
        })
        .catch(error => console.error("Errore nel recupero dell'esercizio:", error));
    }
    setLoading(false)
  }, [id]);


  const isValidSessione = () => {
    const baseValidation = sessione.name?.trim() && sessione.description?.trim();
    const eserciziValidation = sessione.activities.length >= 2;
    const timeValidation = sessione.active_time > 0 && sessione.recovery_time > 0;
    return baseValidation && timeValidation && eserciziValidation;
  };



  const eliminaSessione = async () => {
    setLoading(true)
    if (!id) return;
    try {
      const headers = new Headers();
      //if (token) {
      //  headers.set('Authorization', `Token ${token}`);
      //}
      const response = await fetch(`/api/v0/session/${id}`, {
        method: "DELETE",
        credentials: 'include',
      });
      if (!response.ok) {
        throw new Error("Errore durante l'eliminazione della sessione");
      }
      navigate("/sessioni");
    } catch (error: any) {
      console.error("Errore durante la chiamata DELETE:", error);
      setModalData({
        show: true,
        title: "",
        message: error.message || "Si è verificato un errore durante l'eliminazione dell'esercizio",
        type: MODALTYPE.OK,
      })
    }
    setLoading(false)
  };



  const Modifica = () => {
    navigate("edit")
  }


  const elimina = () => {
    const deleteSession = async () => {
      await eliminaSessione();
    }
    setModalData({
      show: true,
      title: "Elimina elemento",
      message: "Se decidi di procedere, questo elemento verrà eliminato definitivamente dal backoffice.",
      type: MODALTYPE.DELETE,
      action: deleteSession
    })
  }

  useEffect(() => {
    fetchActivities();
  }, []);

  useEffect(() => {
    if (activities.length === 0 || sessione.activities.length === 0) {
      setFilteredActivities([]);
      return;
    }

    const filtered = sessione.activities
      .map(act_id => findEsercizio(act_id))
      .filter(Boolean);

    setFilteredActivities(filtered);
  }, [activities, sessione]);

  const aggiornaPubblicazione = async () => {
    setLoading(true)
    const nuovoStatus = sessione.status === "Published" ? (isValidSessione() ? "Publishable" : "Draft") : "Published";

    try {
      const method = 'PUT';

      const headers = new Headers();
      //if (token) {
      //  headers.set('Authorization', `Token ${token}`);
      //}
      headers.set('Content-Type', 'application/json');
      const requestInit: RequestInit = {
        method,
        headers: headers,
        body: JSON.stringify({ status: nuovoStatus }),
        credentials: 'include',
      }
      const response = await fetch(`/api/v0/session/${id}/partial-update`, requestInit);

      if (!response.ok) {
        const errorData = await response.json();
        const messages = Object.entries(errorData)
          .map(([field, errors]) => `${field}: ${Array.isArray(errors) ? errors.join(', ') : errors}`)
          .join('\n');
        throw new Error(messages);
      }

      navigate('/sessioni');
    } catch (error: any) {
      console.error("Errore durante il salvataggio:", error);
      setModalData({
        show: true,
        title: "",
        message: error.message || "Errore durante il salvataggio della sessione",
        type: MODALTYPE.OK,
      })
    }
    setLoading(false)
  };

  const closeModal = () => setModalData(prev => ({ ...prev, show: false }));

  const findEsercizio = (act_id: number) => {
    return activities.find(el => el.id === act_id)!;
  }

  const statoBadge = sessione.status === "Published"
    ? <span className="badge text-bg-success">Pubblicato</span>
    : <span className="badge text-bg-danger">Non pubblicato</span>;


  if (loading) {
    return (
      <SpinnerODM />
    )
  }

  return (
       <Box
         component="main"
         sx={{
           flexGrow: 1,
           height: "100%",
         }}
       >
         <div className="p-3" style={{ height: "100%" }}>
        <MasterHeader
          tipo={"Sessione"}
          statoBadge={statoBadge}
          elimina={elimina}
          nomeElemento={id == null ? "Nuovo Elemento" : sessione.name}
          salvaModifica={Modifica}
          aggiornaPubblicazione={aggiornaPubblicazione}
          actionButtonName="Modifica"
          status={sessione.status}
          stateSave={false}
          statePublished={sessione.status !== "Published" && !isValidSessione()}
          isEdit={true}
        />
        <Box
          component="main"
          sx={{
            flexDirection: "row",
            height: "100%",
            overflow: "hidden",
            paddingBottom: 17
          }}
        >
          <div
            className="row backgroundPage"
            style={{ height: "calc(100% - 64px)", margin: 0 }}
          >

            <div className="col-4 d-flex flex-column" style={{ height: "100%" }}>
              <div className="d-flex align-items-center mb-2">
                <SearchIcon width={30} />
                <h3 className="ms-3">Riepilogo sessione</h3>
              </div>
              <div style={{ flexGrow: 1, overflowY: "auto" }}>
                <SessioneDetailsTable sessione={sessione} />
              </div>
            </div>

            <div className="col-8 d-flex flex-column" style={{ height: "100%" }}>
              <div className="d-flex align-items-center mb-2">
                <img src={esercizi} alt="icon" width={30} />
                <h3 className="ms-3">Esercizi</h3>
              </div>
              <div style={{ flexGrow: 1, overflowY: "hidden" }}>
                <ODMTable
                  columns={THead}
                  rows={filteredActivities}
                  navTable={"/esercizi/{id}/edit"}
                  edit={true}
                  tooltipColumnIds={tooltipColumnIds}
                />
              </div>
            </div>
          </div>
        </Box>



        
      </div><ModalAlert modalData={modalData} onClose={closeModal} />
    </Box>
  );
};

export default SessionePageV;
